export default {
  OPEN: 'OPEN',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  COMPLETE: 'COMPLETE',
  CANCELED: 'CANCELED'
};
